import { useState, useEffect } from "react";
import logo from "../../Login.png";
import { FaSearch, FaSignOutAlt } from "react-icons/fa"; // Import the search icon
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { supabase } from "../../supabaseClient";
import { useSelector } from "react-redux";

function HeaderContainer({ headerStyle }) {
  const navigate = useNavigate(); // Use useNavigate instead of useHistory
  const [userInfo, setUserInfo] = useState(null);
  const [userName, setUserName] = useState("");
  const [userLocation, setUserLocation] = useState("");
  const user = useSelector((state) => state.auth.user);
  const userEmail = user?.Email || sessionStorage.getItem("User");
  
  useEffect(() => {
    // Use session storage instead of Supabase auth session
    const userId = sessionStorage.getItem("UserId");
    const userEmail = sessionStorage.getItem("User");
    
    if (userId && userEmail) {
      setUserInfo({
        UserID: userId,
        Email: userEmail
      });

      // Fetch user's actual name from database
      fetchUserName(userId);
    } else {
    }
  }, []);
  
  const fetchUserName = async (userId) => {
    try {
      // First try Users table with location info
      const { data: userData } = await supabase
        .from("Users")
        .select(`
          FirstName,
          LastName,
          LocationID
        `)
        .eq("UserID", userId)
        .single();

      if (userData) {
        // Set user name
        if (userData.FirstName || userData.LastName) {
          const name = `${userData.FirstName || ''} ${userData.LastName || ''}`.trim();
          setUserName(name);
        }
      }

      // Query UserLocations for all assigned locations
      const { data: userLocations } = await supabase
        .from("UserLocations")
        .select("Locations:LocationID (Code, Description)")
        .eq("UserID", userId);

      if (userLocations && userLocations.length > 0) {
        const codes = userLocations
          .map((ul) => ul.Locations?.Code || ul.Locations?.Description)
          .filter(Boolean);
        setUserLocation(codes.join(", "));
      } else if (userData?.LocationID) {
        // Fallback to single LocationID from Users table
        const { data: loc } = await supabase
          .from("Locations")
          .select("Code, Description")
          .eq("LocationID", userData.LocationID)
          .single();
        if (loc) {
          setUserLocation(loc.Code || loc.Description);
        }
      }

      if (userData?.FirstName || userData?.LastName) {
        return; // Successfully got name from Users table
      }

      // If not found in Users, try Managers table
      const { data: managerData } = await supabase
        .from("Managers")
        .select("firstname, lastname")
        .eq("UserID", userId)
        .single();

      if (managerData && (managerData.firstname || managerData.lastname)) {
        const name = `${managerData.firstname || ''} ${managerData.lastname || ''}`.trim();
        setUserName(name);
        return;
      }

      // Fallback to email
      setUserName(userEmail || "User");
    } catch (error) {
      setUserName(userEmail || "User");
      setUserLocation(""); // Clear location on error
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem("isUserAuthenticated");
    sessionStorage.removeItem("isAdmin");
    sessionStorage.removeItem("User");
    sessionStorage.removeItem("UserId");
    sessionStorage.removeItem("UserRole");
    sessionStorage.removeItem("customerId");
    sessionStorage.removeItem("jwt_token");
    sessionStorage.removeItem("jwt_refresh_token");
    sessionStorage.removeItem("LocationID");
    sessionStorage.removeItem("LocationIDs");
    navigate("/login");
  };

  return (
    <div className="header-container">
      <div className="header-left flex">
        <div>
          <img src={logo} alt="ACT Logo" className="header-left img" />
        </div>
        <div>
          <h1 className="header-title">
            Welcome, <span>{userName || user?.Email || "User"}</span>
          </h1>
          <p className="header-subtitle">{userLocation || "Airport Assignment"}</p>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="search-input-wrapper">
          <div className="search-input-container">
            <input
              type="text"
              placeholder="Search Flight..."
              className="search-input"
            />
            <FaSearch className="search-icon" />
          </div>
        </div>
        <div className="flex items-center">
          <FaSignOutAlt
            className="logout-icon"
            style={{ right: headerStyle }}
            onClick={handleLogout}
          />
        </div>
      </div>
    </div>
  );
}

export default HeaderContainer;
